<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/documents">Documents</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3"></div>
        <b-form>
            <b-row>
                <b-col md="6">
                    <display-row title="Document No.">{{ doc.number || '-' }}</display-row>
                    <display-row title="File Name">{{ doc.fileName || '-' }}</display-row>
                    <display-row title="Category">{{ doc.category || '-' }}</display-row>
                    <display-row title="Customer">{{ doc.customer || '-' }}</display-row>
                    <display-row title="Created">{{ doc.created || '-' }}</display-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mt-4 mb-3">
                    <h4>Attached PDF</h4>
                </b-col>
                <b-col md="12">
                    <media-thumbnail :title="doc.fileName" :href="doc.fileUrl">Adobe PDF file</media-thumbnail>
                </b-col>
            </b-row>
        </b-form>
        
    </b-card>
</template>

<script>
import DisplayRow from "@/components/DisplayRow.vue";
import MediaThumbnail from "@/components/MediaThumbnail.vue"

export default {
    components: {
        'display-row': DisplayRow,
        'media-thumbnail': MediaThumbnail
    },
    data() {
        return {
            doc: {
                number: 'DOC-001',
                fileName: "02.06.2020 QRT DIGI MERU UTAMA.pdf",
                category: 'QRT',
                customer: "DIGI",
                created: "2020-06-02",
                fileUrl: "https://drive.google.com/file/d/1ADYHsY5RTE7o5kLZqAy68sVR7BN5Q4hx/view?usp=sharing"
            }
        }
    },
    methods: {

    }
}
</script>